import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { getButtonVariantProps, getTrellisButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import { useHighlightedProductsHeaderConfig } from 'pricing-pages-ui/constants/merchCards/HighlightedProductsHeaderConfig';
import { useSelector } from 'react-redux';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';
import { MerchCardLayoutUI } from '../../../v2/components/MerchCardLayoutUI';
import { BaseCardBadge } from '../../../v2/components/merch-card/BaseCardBadge';
import { MerchCardSubheadingContainer } from '../../../v2/containers/merch-card/headings-display/MerchCardSubheadingContainer';
import { MerchCardTitleContainer } from '../../../v2/containers/merch-card/headings-display/MerchCardTitleContainer';
import { useIsInAppAuth } from '../../../v2/hooks/user/useUserInfo';
import CurrentPlanButton from '../../CurrentPlanButton';
import { SuiteFeatures } from '../features-display/SuiteFeatures';
import FreePriceDisplayStyled from '../price-display/FreePriceDisplayStyled';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import { jsx as _jsx } from "react/jsx-runtime";
export const FreeCard = ({
  productLine,
  columnStart,
  trackingSource
}) => {
  var _config$productLine$F;
  const isAppReady = useGlobalLoading();
  const isSeatsRedesignUngated = useSelector(isUngatedForSeatsSelector);
  const isMobile = useIsMobile();
  const isInAppAuth = useIsInAppAuth();
  const config = useHighlightedProductsHeaderConfig();
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  const trellisCtaVariantProps = getTrellisButtonVariantProps({
    variant: 'block'
  });
  const Title = /*#__PURE__*/_jsx(MerchCardTitleContainer, {
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.freeCard.productLevelTitle"
    })
  });
  const SubHeading = /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
    apiName: FreeProducts.HUBSPOT_FREE,
    Subheading: productLine === 'crm' ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.freeCard.description.crm"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: ((_config$productLine$F = config[productLine][FREE]) === null || _config$productLine$F === void 0 ? void 0 : _config$productLine$F.subtitle) || ''
    })
  });
  const Seats = isMobile ? null : isSeatsRedesignUngated ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "merchCards.subtexts.free.current"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "merchCards.subtexts.free.legacy"
  });
  const CTAs = /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !isAppReady,
    heights: [47],
    widths: ['100%'],
    children: isInAppAuth ? /*#__PURE__*/_jsx(CurrentPlanButton, {
      visible: trellisCtaVariantProps.visible
    }) : /*#__PURE__*/_jsx(SignupButton, Object.assign({
      sourceId: "pricing-hero",
      productLine: "crm",
      use: "primary",
      trackingSource: trackingSource
    }, ctaVariantProps))
  });
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `${productLine}-free-card`,
    "data-selenium-id": `${productLine}-free-card`,
    columnStart: columnStart,
    Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
      apiName: FreeProducts.HUBSPOT_FREE
    }),
    Title: Title,
    Subheading: SubHeading,
    Pricing: /*#__PURE__*/_jsx(FreePriceDisplayStyled, {}),
    Seats: Seats,
    CTAs: CTAs,
    Features: /*#__PURE__*/_jsx(SuiteFeatures, {
      productLevel: FREE,
      loading: !isAppReady,
      isCollapsible: isMobile
    })
  });
};